












































import {
  Component, Emit, Prop, Vue,
} from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { join } from 'lodash';

export interface TransactionParticipantDto {
  id: string;
  name: string;
  iban?: string | null;
  synesisCode?: string | null;
  isPayable: boolean;
}

@Component({
  components: { ValidationObserver, ValidationProvider },
})
export default class TransactionParticipantForm extends Vue {
  @Prop({
    type: Boolean,
  })
  readonly isLoading!: boolean;

  @Prop({
    type: String,
    default: '',
  })
  readonly id!: string;

  @Prop({
    type: String,
    default: '',
  })
  readonly name!: string;

  @Prop({
    type: String,
    default: null,
  })
  readonly iban!: string | null;

  @Prop({
    type: String,
    default: null,
  })
  readonly synesisCode!: string | null;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly isPayable!: boolean;

  @Prop({
    type: Boolean,
  })
  readonly hideIban!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly ibanOptional!: boolean;

  @Prop({
    type: Boolean,
  })
  readonly hideSynesisCode!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly synesisCodeRequired!: boolean;

  namePrivate = this.name || '';

  ibanPrivate = this.iban || null;

  synesisCodePrivate = this.synesisCode || null;

  isPayablePrivate = this.isPayable || false;

  get ibanRules() {
    if (this.ibanOptional) {
      return 'iban';
    }

    return 'required|iban';
  }

  get synesisCodeRules() {
    const rules = ['digits:7'];

    if (this.synesisCodeRequired) {
      rules.push('required');
    }

    return join(rules, '|');
  }

  get form() {
    return {
      name: this.namePrivate,
      iban: this.ibanPrivate,
      synesisCode: this.synesisCodePrivate,
      isPayable: this.isPayablePrivate,
    };
  }

  get isEdit() {
    return Boolean(this.id);
  }

  @Emit('submit')
  onSubmit() {
    return {
      ...this.form,
      id: this.id,
    };
  }

  @Emit('cancel')
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClose() {
  }

  @Emit('delete')
  onDelete() {
    return this.id;
  }
}
